export default __webpack_public_path__ + "static/media/DSC_9479.bce86d1f.jpg";